import { createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import { createLogger } from 'redux-logger'
import { persistStore } from 'redux-persist'
import createSagaMiddleware, { END } from 'redux-saga'

import galoMonitorApi from '@galo-monitor/services/apis/galoMonitorApi'
import { AuthenticationTypes } from '@galo-monitor/stores/authentication'

import reducers from './reducers'
import sagas from './sagas'

const middlewares = []

if (process.env.REACT_APP_AMBIENTE === 'development') {
  middlewares.push(createLogger({}))
}

const sagaMiddleware = createSagaMiddleware()
middlewares.push(sagaMiddleware)

const store = createStore(reducers, composeWithDevTools(applyMiddleware(...middlewares)))

store.close = () => store.dispatch(END)
store.persist = () => persistStore(store)
store.runSaga = sagaMiddleware.run
store.runSaga(sagas)

/*
  Add header Authorization when store contains accessToken
  or remove when it not contains accessToken
*/
store.subscribe(() => {
  const { accessToken } = store.getState().authentication

  if (accessToken) {
    galoMonitorApi.defaults.headers.common.Authorization = accessToken
  } else {
    const { Authorization, ...common } = galoMonitorApi.defaults.headers.common || {}
    galoMonitorApi.defaults.headers.common = common
  }
})

galoMonitorApi.interceptors.response.use(
  response => {
    const { accessType } = store.getState().authentication

    if (accessType.status === 'inactive') {
      store.dispatch({
        type: AuthenticationTypes.REDIRECT_ACCESS,
        accessType: { status: 'full', message: null }
      })
    }

    return response
  },
  (error) => {
    const {
      response: { status, data }
    } = error
    const { authenticated, user: { isCompany } } = store.getState().authentication

    const logout = errorObject => store.dispatch({ type: AuthenticationTypes.LOGOUT, error: errorObject })

    if (authenticated) {
      switch(status) {
        case 401:
          logout({ type: 'logout', message: 'expired token error message' })
          break
        case 403:
          if (isCompany) {
            logout({ type: 'logout', message: 'access denied' })
          } else {
            store.dispatch({
              type: AuthenticationTypes.REDIRECT_ACCESS,
              accessType: { status: 'inactive', message: data.message }
            })
          }
          break
        case 500:
          logout({ type: 'logout', message: data?.message ?? 'unexpected error occurred' })
          break
        default: // nope
      }
    }

    return Promise.reject(error)
  }
)

export default store
